var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.621,
    height: 30.621,
    viewBox: "0 0 30.621 30.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-search",
    "data-name": "Icon feather-search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M28.5,16.5a12,12,0,1,1-12-12A12,12,0,0,1,28.5,16.5Z",
    transform: "translate(-4.5 -4.5)",
    fill: "none",
    stroke: "#b3cc1d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M31.5,31.5l-6.525-6.525",
    transform: "translate(-4.5 -4.5)",
    fill: "none",
    stroke: "#b3cc1d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1fe167ac6964057af155fb76abb9334d.svg";
export { ForwardRef as ReactComponent };